import React, { FC } from 'react'

import { Box } from '@material-ui/core'

import Text from '~/components/shared/Text'

import { useCategoryQuantityTextStyles } from './CategoryQuantityText.styles'

interface CategoryQuantityTextProps {
  label: string
  quantity: string | number
}

const CategoryQuantityText: FC<CategoryQuantityTextProps> = ({
  label,
  quantity
}) => {
  const classes = useCategoryQuantityTextStyles()

  return (
    <Box className={classes.root}>
      <Text className={classes.title}>{label}</Text>

      <Text component="span" className={classes.count}>
        {quantity}
      </Text>
    </Box>
  )
}

export default CategoryQuantityText
